<in2-card-box class="card-face front overlay" [card]="card()"></in2-card-box>
<div class="bg-primary flex flex-col card-face back overflow-hidden">
    <h2 class="text-white heading-1 p-4 m-4 mb-0">{{ slide().title }}</h2>
    <div class="text-white p-2 md:p-4 overflow-y-auto w-full h-full flex flex-col justify-between">
        <div class="ht-body align-middle line-clamp lines-8" [innerHTML]="slide().description | safeHtml"></div>
        <a [routerLink]="['/case-study', slide().slug]" class="text-base button border-white text-white mt-4 self-end" i18n="@@caseStudySliderCardReadMore">Read more</a>
    </div>
</div>
